module.exports = __webpack_public_path__ + "img/pd-img37.c0edb578.jpg";